<template>
  <!--Add Page Container-->
  <div
    :style="{
      ...this.getStyle,
    }"
  >
    <footer class="footer">
      <cookie-law theme="base--rounded">
        <div slot="message">
          By using our site you agree to its use of cookies to deliver better
          site experience.
          <a
            class="cookie_policy"
            href="https://www.syngenta-us.com/legal/cookiepolicy.html"
            target="_blank"
            >Cookie Policy</a
          >
        </div>
      </cookie-law>
      <div class="float-right">
        <label>&copy;{{ new Date().getFullYear() }} Syngenta</label>
        <a @click="openUerAgreement()" target="_blank">User Agreement</a>
      </div>
      <div class="clearfix"></div>
    </footer>
  </div>
</template>

<script>
import CookieLaw from "vue-cookie-law";

export default {
  components: {
    CookieLaw,
  },
  props: ["isDefaultStyle"],
  name: "Footer",
  methods: {
    openUerAgreement() {
      var agreementWindow = window.open(`./userAgreement.html`, "_blank");
      var elem = document.createElement("img");
      var imgPath = require(`../../assets/images/${this.$store.state.style["--footer_logo"]}`);
      elem.setAttribute("src", imgPath);

      agreementWindow.onload = function () {
        agreementWindow.document
          .getElementById("agreement-header")
          .appendChild(elem);
      };
    },
  },
  computed: {
    getStyle: function () {
      return this.isDefaultStyle ? this.$store.state.style : null;
    },
  },
  created: function () {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.Cookie--base--rounded .Cookie__button {
  background: var(--button_success, #19a04b) !important;
}
footer {
  width: 100%;
  color: #2b3139;
  font-size: 12px;
  padding: 10px 35px;
  position: var(--footer_position);
  bottom: 0;
  font-weight: var(--footer-font_weight);
}
footer a,
footer a:hover {
  color: var(--footer_color, #ffff) !important;
  margin-right: 10px;
}
footer a:hover {
  text-decoration: underline !important;
  cursor: pointer;
}
footer label {
  border-right: 1px solid #2b3139;
  padding-right: 15px;
  margin-right: 15px;
  color: var(--footer_color, #ffff);
}
footer a.cookie_policy,
footer a.cookie_policy:hover {
  color: var(--cookiePolicy_color, #0078cd) !important;
}
@media screen and (min-height: 650px) {
  footer {
    position: absolute;
    bottom: 0;
    &.footer {
      position: var(--footer_position_mobile);
    }
  }
}
</style>
